// Custom helicopter SVG (lucide-react has none)
export default function Helicopter({ className, style }) {
  return (
    <svg
      className={className}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="12" y1="6" x2="12" y2="9" />
      <path d="M5 14a3 3 0 0 1 3-3h6l3 3v3H5z" />
      <path d="M17 13h4l-2 2" />
      <line x1="20" y1="12" x2="22" y2="14" />
      <line x1="22" y1="12" x2="20" y2="14" />
      <line x1="4" y1="19" x2="18" y2="19" />
      <line x1="6" y1="17" x2="6" y2="19" />
      <line x1="16" y1="17" x2="16" y2="19" />
    </svg>
  );
}
